module.exports = __webpack_public_path__ + "img/caret-white-link-info.df9d2497.svg";